import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Handball = () => {
  return (
    <SportsLayoutComp name={'Handball'}/>
  )
}

export default Handball